var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 5.94971V14.283C18.3332 14.8356 18.1137 15.3655 17.723 15.7562C17.3323 16.1469 16.8024 16.3664 16.2498 16.3664H3.74984C3.1973 16.3664 2.6674 16.1469 2.2767 15.7562C1.886 15.3655 1.6665 14.8356 1.6665 14.283V5.94971",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 5.94954C18.3332 5.39701 18.1137 4.86711 17.723 4.47641C17.3323 4.0857 16.8024 3.86621 16.2498 3.86621H3.74984C3.1973 3.86621 2.6674 4.0857 2.2767 4.47641C1.886 4.86711 1.6665 5.39701 1.6665 5.94954L8.89567 10.4634C9.22678 10.6704 9.60938 10.7801 9.99984 10.7801C10.3903 10.7801 10.7729 10.6704 11.104 10.4634L18.3332 5.94954Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIc);
export default __webpack_public_path__ + "static/media/mail-ic.f3c0b0fde0a64dda4c1b7fa751749280.svg";
export { ForwardRef as ReactComponent };